import { styles } from '@app/services/app-styles.service';

const tooltip = {
    root: {
        background: styles().primary,
        color: '#fff',
    },
};

export default tooltip;
